<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1 style="padding-bottom:15px;">Acknowledgement</h1>
<p>I would like to thank the PCC of St Paul’s for giving me the time and the opportunity to write this, the St Paul’s family for their love and encouragement, my long-suffering wife without whose wisdom I would not be the person that I am and to my editor, Lesley Thomas, who ordered my stream of consciousness into a readable form.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?aabf7f56